'use strict';

var childrenOfType = require('../../../_virtual/childrenOfType.js_commonjs-exports.js');
var index = require('../../array.prototype.find/index.js');
require('./helpers/getComponentName.js');
require('./helpers/renderableChildren.js');
require('./helpers/wrapValidator.js');
var getComponentName = require('../../../_virtual/getComponentName.js_commonjs-exports.js');
var renderableChildren = require('../../../_virtual/renderableChildren.js_commonjs-exports.js');
var wrapValidator = require('../../../_virtual/wrapValidator.js_commonjs-exports.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _arrayPrototype = _interopRequireDefault(index);

var _getComponentName = _interopRequireDefault(getComponentName.__exports);

var _renderableChildren = _interopRequireDefault(renderableChildren.__exports);

var _wrapValidator = _interopRequireDefault(wrapValidator.__exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function onlyTypes(types, children, componentName) {
  if (!children.every(function (child) {
    return child && (0, _arrayPrototype["default"])(types, function (Type) {
      return Type === '*' || child.type === Type;
    });
  })) {
    var typeNames = types.map(_getComponentName["default"]).join(', or ');
    return new TypeError("`".concat(componentName, "` only accepts children of type ").concat(typeNames));
  }

  return null;
}

function isRequired(types, children, componentName) {
  if (children.length === 0) {
    var typeNames = types.map(_getComponentName["default"]).join(', or ');
    return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(typeNames));
  }

  return null;
}

function childrenOfType() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  if (types.length < 1) {
    throw new TypeError('childrenOfType: at least 1 type is required');
  }

  function validator(props, propName, componentName) {
    return onlyTypes(types, (0, _renderableChildren["default"])(props[propName]), componentName);
  }

  validator.isRequired = function (props, propName, componentName) {
    var children = (0, _renderableChildren["default"])(props[propName]);
    return isRequired(types, children, componentName) || onlyTypes(types, children, componentName);
  };

  return (0, _wrapValidator["default"])(validator, 'childrenOfType', types);
}

var _default = childrenOfType;
exports["default"] = _default;

}(childrenOfType.__exports));
